import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { API, ComparisonPath } from '@cdba/shared/constants/api';
import { SchaefflerBomIdentifier } from '@cdba/shared/models';

import { Comparison } from '../../shared/models/comparison.model';

@Injectable({ providedIn: 'root' })
export class ComparisonService {
  private readonly httpClient = inject(HttpClient);

  getComparison(
    identifiers: SchaefflerBomIdentifier[]
  ): Observable<Comparison> {
    const path = `${API.v1}/${ComparisonPath}`;

    return this.httpClient.post<Comparison>(path, identifiers);
  }
}
